import { AlignmentType, BorderStyle, convertInchesToTwip, LevelFormat, WidthType } from 'docx';

export const FONT_COLOR = '004B52'; // $color-sapphire-500
export const FONT_FAMILY = 'Arial';
export const MAX_IMAGE_WIDTH = 200;
export const CHECKBOX_SYMBOL = '\u2610'; // ☐
export const RADIO_SYMBOL = '\u25cb'; // ○
export const FILLED_CIRCLE_SYMBOL = '\u25cf'; // ●
export const BULLET_SYMBOL = '•';
export const DASH_SYMBOL = '-';
export const EM_SPACE = '\u2003'; // Wide space for formatting
export const NUMERATOR_FULL_LOGO_URL =
  'https://imgproxy-cdn-prd.survey.numerator.cloud/yUHPlLyPWV9h_UGCxrl2B7vbw6MBrCS_PYPg5Zz_YVI/q:95/dpr:2/g:ce/rs:fit:600:600:0/czM6Ly9pbnN0YW50c3VydmV5LWVrcy1wcmQtbWVkaWEtczMtYnVja2V0L3Bob3RvdXBsb2Fkcy82Njg3YzM0Ni02NzdmLTRlYTItYTcxNC1mYmRhNmEwMzE2ODgucG5n';

export const DEFAULT_SPACING = {
  after: convertInchesToTwip(0.08),
  before: convertInchesToTwip(0.08),
};

export const HEADER_SPACING = {
  after: convertInchesToTwip(0.08),
  before: convertInchesToTwip(0.16),
};

export const BLOCK_SPACING = {
  after: convertInchesToTwip(0.12),
  before: convertInchesToTwip(0.2),
};

export const QUESTION_SPACING = {
  before: convertInchesToTwip(0.25),
};

export const BASE_TEXT_CONFIG = { color: FONT_COLOR, font: FONT_FAMILY, size: 22 }; // 11pt
export const SMALL_TEXT_SIZE = 18; // 9pt
export const BOLD_TEXT_CONFIG = { ...BASE_TEXT_CONFIG, bold: true };
export const NESTED_QUESTION_TEXT_CONFIG = { ...BASE_TEXT_CONFIG, size: 20 }; // 10pt
export const NESTED_QUESTION_TITLE_TEXT_CONFIG = { ...BOLD_TEXT_CONFIG, size: 20 }; // 10pt
export const OPTION_TEXT_CONFIG = { ...BASE_TEXT_CONFIG, size: SMALL_TEXT_SIZE };
export const A_CHAR_CODE = 65; // 'A'

export const INDENT_SM = convertInchesToTwip(0.4);
export const INDENT_MD = convertInchesToTwip(0.5);
export const INDENT_LG = convertInchesToTwip(0.75);
export const INDENT_XL = convertInchesToTwip(1);

export const NESTED_QUESTION_SPACING = {
  before: convertInchesToTwip(0.16),
};

export const DEFAULT_QUESTION_RENDER_CONTEXT = {
  answerImageIndent: INDENT_LG,
  answerIndent: INDENT_LG,
  answerTextConfig: BASE_TEXT_CONFIG,
  descriptiveChildIndent: INDENT_LG,
  descriptiveIndent: INDENT_SM,
  descriptiveTextSize: SMALL_TEXT_SIZE,
  gridBodyTextConfig: BASE_TEXT_CONFIG,
  gridHeaderTextConfig: BOLD_TEXT_CONFIG,
  gridIndent: INDENT_MD,
  gridWidth: 90,
  metadataIndent: INDENT_SM,
  metadataTextConfig: OPTION_TEXT_CONFIG,
  questionImageIndent: INDENT_MD,
  sectionHeaderIndent: INDENT_SM,
  titleOptions: {},
};

export const NESTED_QUESTION_RENDER_CONTEXT = {
  ...DEFAULT_QUESTION_RENDER_CONTEXT,
  answerImageIndent: INDENT_XL,
  answerIndent: INDENT_XL,
  answerTextConfig: NESTED_QUESTION_TEXT_CONFIG,
  descriptiveChildIndent: INDENT_XL,
  descriptiveIndent: INDENT_LG,
  gridBodyTextConfig: OPTION_TEXT_CONFIG,
  gridHeaderTextConfig: { ...BOLD_TEXT_CONFIG, size: SMALL_TEXT_SIZE },
  gridIndent: INDENT_LG,
  gridWidth: 82,
  metadataIndent: INDENT_LG,
  questionImageIndent: INDENT_LG,
  sectionHeaderIndent: INDENT_LG,
  titleOptions: {
    indent: INDENT_LG,
    spacing: NESTED_QUESTION_SPACING,
    textConfig: NESTED_QUESTION_TITLE_TEXT_CONFIG,
  },
};

export const BORDERLESS_TABLE_CONFIG = {
  borders: {
    bottom: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    insideHorizontal: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    insideVertical: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    left: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    right: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    top: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
  },
  width: { size: 100, type: WidthType.PERCENTAGE },
};

export const BULLETED_LIST_CONFIG = {
  levels: [
    {
      alignment: AlignmentType.START,
      format: LevelFormat.BULLET,
      level: 0,
      style: {
        paragraph: {
          indent: { hanging: convertInchesToTwip(0.25), left: convertInchesToTwip(0.5) },
        },
        run: {
          bold: true,
          color: FONT_COLOR,
          font: FONT_FAMILY,
        },
      },
      text: '●',
    },
  ],
  reference: 'bulleted-list',
};
